import React from "react";
import { styled, Tooltip, tooltipClasses, TooltipProps } from "@mui/material";
import { InsightIcon } from "./InsightIcon";
import { MultiInsightTooltipContent } from "./MultiInsightTooltipContent";

interface MultiInsightTooltipProps {
  insightIds: string[];
  showDocumentLink?: boolean;
}

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    padding: 12,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 11,
    border: `1px solid ${theme.palette.divider}`,
    minWidth: 200,
  },
}));

export const MultiInsightTooltip: React.FC<MultiInsightTooltipProps> = ({
  insightIds,
  showDocumentLink = true,
}) => {
  return (
    <StyledTooltip
      title={
        <MultiInsightTooltipContent
          insightIds={insightIds}
          showDocumentLink={showDocumentLink}
        />
      }
      placement="auto"
      PopperProps={{
        modifiers: [
          {
            name: "flip",
            enabled: true,
          },
          {
            name: "preventOverflow",
            enabled: true,
            options: {
              boundary: window,
            },
          },
        ],
      }}
    >
      <span>
        <InsightIcon>{insightIds.length}</InsightIcon>
      </span>
    </StyledTooltip>
  );
};
